
const PageTest = () => {

  return (
    <div>
      Ceci est un test
    </div>



  );
};

export default PageTest;


